// extracted by mini-css-extract-plugin
module.exports = {"regular":"button_regular__akbeB","purple":"button_purple__1Y4nN","violet":"button_violet__2uHYG"};